import React from 'react';
import { Col, InputGroup, Input, Label } from 'reactstrap';
import i18n from '../../../../../i18next';

import AvailabilityHeading from './AvailabilityHeading';

const AvailabilityServices = props => {

    const checkedIfMathes = (restaurantOrderTypeId) => {
        const { productOrderTypes } = props.state.currentProduct;

        if (productOrderTypes !== undefined && productOrderTypes !== null && productOrderTypes.length > 0) {
            for (let i = 0; i < productOrderTypes.length; i++) {
                const currentOrderType = productOrderTypes[i];

                if (currentOrderType.id == restaurantOrderTypeId) {

                    return true;
                }
            }
        }

        return false;
    }

    return (
        <Col>
            <AvailabilityHeading text={i18n.t('screens:productScreen.productAvailableFor')} />
            {
                props.state.restaurantOrderTypes.length > 0 ?
                    props.state.restaurantOrderTypes.map((orderType, i) => {

                        const transformToLocalize = () => { // Transforms item.value so it can be translated.
                            switch (orderType.value) {
                                case "Collection":
                                    return "collection";
                                case "Delivery":
                                    return "delivery";
                                case "Dine In":
                                    return "dinein"
                                case "Curbside":
                                    return "curbside";
                                case "In Store":
                                    return 'instore';
                                default:
                                    return;
                            }
                        }

                        return (
                            <Col sm={5} key={`orderType${i}`} style={{ display: 'inline-block' }}>
                                <InputGroup key={orderType.id + i} style={{ marginLeft: 4 }}>
                                    <Label for={`${orderType.id}`} style={{ paddingRight: 10 }}>
                                        {i18n.t(`screens:restaurantsMainContainer.${transformToLocalize(orderType.value)}`)}
                                    </Label>
                                    <Input style={{ position: 'static', marginLeft: 0, marginTop: 6 }} type="checkbox" name={orderType.value}
                                        id={`${orderType.id}`}
                                        checked={checkedIfMathes(orderType.id)}
                                        onChange={props.changeSelectedOrderTypesState}
                                    />
                                </InputGroup>
                            </Col>
                        );
                    }) : null
            }
        </Col>
    );
}

export default AvailabilityServices;


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/availability/AvailabilityServices.js